import { IResponse } from "models";

export enum ActionType {
  CONTRACT_INFORMATION_DOWNLOAD_PDF = "action/CONTRACT_INFORMATION_DOWNLOAD_PDF",
  CONTRACT_INFORMATION_DOWNLOAD_PDF_SUCCESS = "action/CONTRACT_INFORMATION_DOWNLOAD_PDF_SUCCESS",
  CONTRACT_INFORMATION_DOWNLOAD_PDF_ERROR = "action/CONTRACT_INFORMATION_DOWNLOAD_PDF_ERROR",
  CONTRACT_INFORMATION_DOWNLOAD_PDF_RESET = "action/CONTRACT_INFORMATION_DOWNLOAD_PDF_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDownloadPDFContractResponse extends IResponse {
  result: any;
}
